import { render, staticRenderFns } from "./ModalPublistEvent.vue?vue&type=template&id=6e2a54ba&scoped=true&"
import script from "./ModalPublistEvent.vue?vue&type=script&lang=js&"
export * from "./ModalPublistEvent.vue?vue&type=script&lang=js&"
import style0 from "./ModalPublistEvent.vue?vue&type=style&index=0&id=6e2a54ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a54ba",
  null
  
)

export default component.exports